import {noop} from '@github-ui/noop'
import {useCallback, useRef, useState} from 'react'

import {CreateArtifactDialog} from './CreateArtifactDialog'

type UseCreateArtifactDialogArgs = {
  resourceId?: number | null
  onCreated?: () => void
}

export function useCreateArtifactDialog({resourceId, onCreated = noop}: UseCreateArtifactDialogArgs) {
  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)
  const resourceIdIsReady = typeof resourceId === 'number' && resourceId > 0

  const openCreateArtifactDialog = useCallback(() => {
    if (!resourceIdIsReady) return
    setCreateDialogOpen(true)
  }, [resourceIdIsReady])

  const closeCreateArtifactDialog = useCallback(() => {
    setCreateDialogOpen(false)
  }, [])

  const createArtifactDialog =
    createDialogOpen && resourceIdIsReady ? (
      <CreateArtifactDialog
        resourceId={resourceId}
        onClose={closeCreateArtifactDialog}
        onCreated={onCreated}
        returnFocusRef={triggerRef}
      />
    ) : null

  return {createArtifactDialog, openCreateArtifactDialog, resourceIdIsReady, triggerRef}
}
